import React, { createRef, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import * as constants from '../../globals/constants'
import { getComma } from '../../utils/getComma'

// components
import { Selector } from '../../components'
import Button from '../../components/atom/button/Button'
import ToggleBtn from '../../components/atom/toggleBtn/ToggleBtn'
import Empty from '../../pages/reviewList/components/Empty'
import ChkBox from '../atom/checkBox/ChkBox'
import DropDown from '../dropdown/DropDown'
import Loading from '../../components/atom/loading/Loading'

// images
import DefaultImg from '../../assets/image/menu/ic-menu-default.svg'

const ItemMenu = ({
  dataItems,
  dataItem,
  chkNon,
  checkedItems,
  setCheckedItems,
  saleItems,
  setSaleItems,
  nonsaleItems,
  setNonSaleItems,
  postSaleItem,
  isInit,
  getLoading,
}) => {
  const user = JSON.parse(localStorage.getItem('user'))

  // 탭(메뉴, 옵션)
  const [selectTabIdx, setSelectTabIdx] = useState(0)
  const navigate = useNavigate()

  // 데이터 배열 담는 곳
  const [categoryList, setCategoryList] = useState() //  categoryList 담는 곳
  const [itemList, setItemList] = useState() // itemList 담는 곳
  const [combinedItemList, setCombinedItemList] = useState() // itemList 담는 곳

  // 숨김 처리시(hide)
  // const hideRef = useRef(null)
  const hideRefs = Array.from({ length: dataItem.length }).map(() =>
    createRef(),
  )

  // 정렬 dropdown
  const sortOption = ['등록순', '오름차순', '내림차순']
  const [sortOptionStatus, setSortOptionStatus] = useState(sortOption[0])

  const handleTab = (flag) => {
    // setOrderIncludeCancel(true)
    setSelectTabIdx(flag)

    if (flag === 0) {
      navigate('/itemList')
    }
    if (flag === 1) {
      navigate('/optionList')
    }
  }

  // 판매중 버튼 클릭
  const handleSaleClick = () => {
    // console.log('combinedItemList', combinedItemList)
    if (checkedItems.length === 0) {
      alert('메뉴를 선택해주세요.')
      return
    }

    const updatedSaleItems = [
      ...new Set([
        ...saleItems,
        ...checkedItems.filter((item) => {
          // combinedItemList에서 saleYn이 'Y'가 아닌 항목만 필터링
          const combinedItem = combinedItemList.find(
            (combined) => combined.itemCode === item,
          )
          return combinedItem && combinedItem.saleYn !== 'Y'
        }),
      ]),
    ]

    setSaleItems(updatedSaleItems)
    postSaleItem(updatedSaleItems, [])
  }

  // 숨김 버튼 클릭
  const handleNonSaleClick = () => {
    if (checkedItems.length === 0) {
      alert('메뉴를 선택해주세요.')
      return
    }

    const updatedNonSaleItems = [
      ...new Set([
        ...saleItems,
        ...checkedItems.filter((item) => {
          // combinedItemList에서 saleYn이 'N'가 아닌 항목만 필터링
          const combinedItem = combinedItemList.find(
            (combined) => combined.itemCode === item,
          )
          return combinedItem && combinedItem.saleYn !== 'N'
        }),
      ]),
    ]

    setNonSaleItems(updatedNonSaleItems)
    postSaleItem([], updatedNonSaleItems)
  }

  // 전체 체크박스 핸들러
  const handleAllChecked = (checked) => {
    if (checked) {
      // 전체 선택 클릭 시 데이터의 모든 아이템(id)를 담은 배열로 checkItems 상태 업데이트
      const idArray = []
      itemList.forEach((item) => idArray.push(item.itemCode))
      setCheckedItems(idArray)
    } else {
      // 전체 선택 해제 시 checkItems 를 빈 배열로 상태 업데이트
      setCheckedItems([])
    }
  }

  // 개별 체크박스 핸들러
  const handleCheckedItem = (checked, chk) => {
    if (checked) {
      setCheckedItems((prev) => [...prev, chk])
    } else {
      setCheckedItems(checkedItems.filter((item) => item !== chk))
    }
  }

  // 테이블 toggle 개별 스위치 핸들러
  const handleSellChange = (item, newValue, index) => {
    item.saleYn = newValue
    const itemRef = hideRefs[index].current

    // 숨김
    if (item.saleYn === 'N') {
      setNonSaleItems((prevNonSaleItems) => {
        // console.log('setNonSaleItems prevNonSaleItems : ', prevNonSaleItems)
        // console.log('setNonSaleItems item.itemCode : ', item.itemCode)
        const newNonSaleItems = [item.itemCode]
        itemRef.classList.add('hide')
        return newNonSaleItems
      })
    }
    // 판매중
    if (item.saleYn === 'Y') {
      setSaleItems((prevSaleItems) => {
        // console.log('setSaleItems prevSaleItems : ', prevSaleItems)
        // console.log('setSaleItems item.itemCode : ', item.itemCode)
        const newSaleItems = [item.itemCode]

        itemRef.classList.remove('hide')
        return newSaleItems
      })
    }
  }

  useEffect(() => {
    setCategoryList(dataItems)

    let sortedItemList = dataItem.slice() // 기존 배열 복사
    if (sortOptionStatus === '오름차순') {
      sortedItemList.sort((a, b) => {
        return a.itemName.localeCompare(b.itemName)
      })
    } else if (sortOptionStatus === '내림차순') {
      sortedItemList.sort((a, b) => {
        return b.itemName.localeCompare(a.itemName)
      })
    }

    // 정렬된 리스트를 상태로 설정
    if (sortOptionStatus === '등록순') {
      setItemList(dataItem)
    } else {
      setItemList(sortedItemList)
    }
  }, [dataItems, dataItem, sortOptionStatus])

  useEffect(() => {
    if (itemList) {
      const menuItems = itemList.filter((item) => item.saleYn === 'Y')
      const hiddenItems = itemList.filter((item) => item.saleYn === 'N')
      const combinedItems = [...menuItems, ...hiddenItems]

      setCombinedItemList(combinedItems)
    }
    if (chkNon) {
      setCheckedItems([])
    }
  }, [itemList])

  return (
    <>
      {getLoading ? (
        <Loading />
      ) : (
        <>
          <TableHeaderBox>
            <Selector
              leftText={'메뉴관리'}
              rightText={'옵션관리'}
              selectedIdx={selectTabIdx}
              handleTab={handleTab}
            />
            <div className="tableRight">
              <DropDown
                className="sortDropdown"
                defaultOption={'등록순'}
                options={sortOption}
                // setOption={handleSortOptionChange}
                setOption={setSortOptionStatus}
                value={sortOptionStatus}
              />
              <Button
                type="button"
                width={69 + 'px'}
                height={28 + 'px'}
                radius={4 + 'px'}
                onClick={handleSaleClick}
              >
                판매중
              </Button>
              <Button
                type="button"
                width={69 + 'px'}
                height={28 + 'px'}
                radius={4 + 'px'}
                onClick={handleNonSaleClick}
              >
                숨김
              </Button>
            </div>
          </TableHeaderBox>
          {dataItem && dataItem.length === 0 ? (
            <Empty pointTxt={'조회된 상품'} txt={'이 없습니다.'} />
          ) : (
            <>
              <TableMenu>
                <MenuTh>
                  <div className="custom-checkbox">
                    <ChkBox
                      type="checkbox"
                      id={'allChk'}
                      checked={
                        checkedItems.length === itemList?.length ? true : false
                      }
                      onChange={(e) => handleAllChecked(e.target.checked)}
                    />
                  </div>
                  <div>카테고리</div>
                  <div>메뉴</div>
                  <div>가격</div>
                  <div>판매상태</div>
                </MenuTh>
                {combinedItemList?.map((item, i) => {
                  const itemClassName =
                    item.saleYn === 'N' ? 'MenuItem hide' : 'MenuItem'

                  return (
                    <MenuItem
                      key={i}
                      ref={hideRefs[i]}
                      className={itemClassName}
                    >
                      <ChkBox
                        id={item.itemCode}
                        // checked={checkedItems[i]}
                        checked={
                          checkedItems.includes(item.itemCode) ? true : false
                        }
                        value={item.itemCode}
                        onChange={(e) =>
                          handleCheckedItem(e.target.checked, item.itemCode)
                        }
                      />
                      <p className="categoryName">
                        {item.categoryList[0].categoryName}
                      </p>
                      <div className="menuTitBox">
                        <div className="menuImgbox">
                          <img
                            src={
                              !item.cImg
                                ? DefaultImg
                                : `${constants.IMG_URL + item.cImg}`
                            }
                            alt="상품사진"
                            className="rounded-circle"
                          />
                        </div>
                        <p className="menuTxt">{item.itemName}</p>
                      </div>
                      <p className="menuPrice">{getComma(item.salePrice)}원</p>
                      <ToggleBtn
                        yn={item.saleYn}
                        setYn={(newValue) => {
                          handleSellChange(item, newValue, i)
                        }}
                        id={i + item.itemCode}
                        width={79}
                      />
                    </MenuItem>
                  )
                })}
              </TableMenu>
            </>
          )}
        </>
      )}
    </>
  )
}

export default ItemMenu

const TableMenu = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const MenuTh = styled.li`
  padding: 15px;
  display: grid;
  grid-template-columns: 0.5fr minmax(180px, 1.2fr) 3fr 1fr 0.7fr;
  align-items: center;
  justify-items: center;
  background-color: #f3f3f3;
  text-align: center;
  color: #8a8a8a;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
`

const MenuItem = styled.li`
  padding: 15px;
  display: grid;
  grid-template-columns: 0.5fr minmax(180px, 1.2fr) 3fr 1fr 0.7fr;
  align-items: center;
  justify-items: center;
  text-align: center;
  border-bottom: 1px solid #e5e5e5;
  color: #000;

  .categoryName {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1.5;
    font-size: 16px;
    font-weight: 700;
    color: #000;
    overflow: hidden;
    word-break: break-all;
    padding: 0 10px;
  }

  .menuTitBox {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 10px;
  }
  .menuImgbox {
    width: 80px;
    height: 80px;
    min-width: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
  }
  .rounded-circle {
    width: 100%; 
    // height: 100%;
    object-fit: cover;
  }
  .menuTxt {
    font-size: 16px;
    color: #000;
    overflow: hidden;
    white-space: normal;
    text-overflow: ellipsis;
  }
  .menuPrice {
    font-size: 16px;
    font-weight: 700;
    color: #000;
  }
  /* 숨김 처리로 변할시 */
  &.hide {
    opacity: 0.5;
  }
`
const TableHeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* align-items: center; */
  margin-bottom: 28px;
  @media ${(props) => props.theme.tablet} {
    display: flex;
    flex-direction: column;
  }

  .tableRight {
    display: flex;
    flex-direction: row;
    justify-content: end;
    align-items: center;
    gap: 7px;
    margin-top: 40px;
  }
  .sortDropdown {
    width: 165px;
  }
`
